import React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'
export const ClearValueButton = ({
  onClear,
  children,
}: React.PropsWithChildren<{ onClear: () => void }>) => {
  return (
    <button className={'ClearValue_clear'} onClick={onClear}>
      <Text.Normal size="300" weight="medium" color="radicalRed1200">
        {children}
      </Text.Normal>
    </button>
  )
}
